<template>
	<div class="container-sm mh-100 pt-10">
		<LayoutHeaderSection>
			<template #title>
				<LayoutTextSection text="Perfil del usuario" :breadcrumb="true" />
			</template>
			<template #actions>
				<div class="hstack gap-2 justify-content-md-end">
					<router-link :to="{ name: 'account.setting.password' }" class="btn btn-sm btn-neutral rounded-pill"><i class="bi bi-asterisk pe-2"></i>Contraseña</router-link>
				</div>
			</template>
		</LayoutHeaderSection>
		<main class="pt-8 vstack gap-10">
			<CommonFormWrapper submitText="Guardar" :cancelUrl="{ name: 'home' }" :submitting="submitting" :errors="validationExternal" @submit="submit">
				<template #body>
					<CommonFormInputText v-model="form.name" title="Nombre" subtitle="Obligatorio" placeholder="Ingresa tu nombre" :focus="true" :validation="validation.name" />
					<CommonFormInputImage v-model="form.avatar" :imageUrl="form?.avatar_url" title="Avatar" titleModal="Cambiar avatar" :rounded="true" @remove="removeImage" />
				</template>
			</CommonFormWrapper>
		</main>
	</div>
</template>

<script>
	import { reactive, computed } from 'vue';
	import store from '@/store';
	import _ from 'lodash';
	import useVuelidate from '@vuelidate/core';
	import { helpers } from '@vuelidate/validators';
	import { required, minLength, maxLength } from '@/helpers/i18n/validators';
	import composableForm from '@/composables/form';
	import composableRedirect from '@/composables/redirect';
	import AuthRepository from '@/repositories/modules/Auth';

	export default {
		setup() {
			const { submitting, validationExternal, catchError } = composableForm();
			const { redirectBack } = composableRedirect();
			const user = computed(() => store.getters['auth/user']);

			const form = reactive({
				email: user.value?.email,
				name: user.value?.name,
				avatar: null,
				avatar_url: user.value?.avatar_url
			});

			const validation = useVuelidate({
				name: {
					required,
					minLength: minLength(3),
					maxLength: maxLength(150)
				}
			}, form);

			const submit = async () => {
				if(submitting.value) return;
				validationExternal.value = [];
				if(!await validation.value.$validate()) return;

				submitting.value = true;

				//Formatea el teléfono
				await AuthRepository.update(form).then((response) => {
					store.dispatch('auth/setUser', response.data);
					redirectBack();
				}).catch(catchError);

				submitting.value = false;
			}

			const removeImage = () => {
				form.avatar_url = null;
			}

			return { form, submit, removeImage, submitting, validation, validationExternal };
		}
	}
</script>